// @flow
import React, { Component } from 'react';
import { MdLock } from 'react-icons/md';
import { IoIosCloudDone } from 'react-icons/io';
import { FaRegLightbulb } from 'react-icons/fa';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cx from 'classnames';
import type { State } from 'store';
import { type ContextRouter, Link, withRouter } from 'react-router-dom';
import type { UserData } from 'store/modules/user';
import Button from 'components/common/Button';
import './QuotingAbout.scss';

type Props = {
  user: ?UserData,
} & ContextRouter;

class QuotingAbout extends Component<Props> {
  render() {
    const { user } = this.props;
    const rule = user && user.rule;
    const isEquivalentToSeller = rule === 'admin' || rule === 'seller';

    return (
      <div className="QuotingAbout">
        <div className="row">
          <div className="col-lg-4">
            <div className="about-box about-light text-center p-3">
              <div className="about-icon mb-4">
                <FaRegLightbulb />
              </div>
              <h4 className="font-weight-light">
                <div className="text-dark">1분안에 견적 요청</div>
              </h4>
              <div className="text-muted f-14">엑셀 서식만 작성해서 업로드하면 견적요청 끝</div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="about-box about-light text-center p-3">
              <div className="about-icon mb-4">
                <IoIosCloudDone />
              </div>
              <h4 className="font-weight-light">
                <div className="text-dark">모든 제품 견적 요청</div>
              </h4>
              <div className="text-muted f-14">
                구매, 비교 견적을 위해 등록되지 않은 제품도 견적 요청 가능
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="about-box about-light text-center p-3">
              <div className="about-icon mb-4">
                <MdLock />
              </div>
              <h4 className="font-weight-light">
                <div className="text-dark">나만의 견적함</div>
              </h4>
              <div className="text-muted f-14">
                나만의 견적함을 통해서 더욱 편하게 견적서 관리 가능
              </div>
            </div>
          </div>
        </div>
        <div className="quote-btn">
          {isEquivalentToSeller ? (
            <Button large color="red" to={'/estimate-box'}>
              견적서 등록하기
            </Button>
          ) : (
            <Button
              large
              color="red"
              className={cx({ 'tip-rule': user })}
              {...(user
                ? { 'data-tip': '파트너만 이용가능 합니다.' }
                : { to: '/login?next=/estimate-box' })}
            >
              판매처 견적서 등록
            </Button>
          )}
          {user ? (
            <Button large color="blue" to={'/estimate'}>
              견적 요청 하기
            </Button>
          ) : (
            <Button large color="blue" to={'/login?next=/estimate'}>
              견적 요청 하기
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(
    ({ base, user }: State) => ({
      landing: base.landing,
      user: user.user,
    }),
    () => ({}),
  ),
)(QuotingAbout);



// WEBPACK FOOTER //
// ./src/components/quoting/QuotingAbout/QuotingAbout.js